import React, { useState } from "react";
import { toast } from "sonner";
import { MessageCircle, Copy, QrCode, Download } from "lucide-react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { trackInitiative } from "../lib/initiativeTrack";

// URL pubblico della landing dell'iniziativa, con prefisso /slug del circuito se la console è aperta su /slug/...
export function initiativeUrl(slug, src = "share") {
  const seg = window.location.pathname.split("/")[1];
  const t = localStorage.getItem("kl_tenant");
  const prefix = t && seg === t ? `/${t}` : "";
  return `${window.location.origin}${prefix}/scopri/iniziativa/${slug}?src=${src}`;
}

export function shareText(d, appName) {
  const parts = [`${d.headline}${d.subtitle ? ` – ${d.subtitle}` : ""}`, d.period, d.countdown, `Scopri l'iniziativa di ${appName || "il circuito"}:`, initiativeUrl(d.slug, "whatsapp")];
  return parts.filter(Boolean).join("\n");
}

// Condivisione iniziativa per lo staff: WhatsApp (wa.me), copia link, QR code stampabile
export default function InitiativeShare({ d, appName, compact = false, idSuffix = "" }) {
  const [qr, setQr] = useState(false);
  if (!d || !d.publish_landing || d.slug === d.id) return null;
  const url = initiativeUrl(d.slug);
  const qrSrc = (size) => `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&margin=8&bgcolor=ffffff&color=18181c&data=${encodeURIComponent(initiativeUrl(d.slug, "qr"))}`;
  const copy = () => { navigator.clipboard.writeText(url); toast.success("Link copiato"); trackInitiative(d.slug, "share_copy", "admin"); };
  const wa = `https://wa.me/?text=${encodeURIComponent(shareText(d, appName))}`;
  const cls = compact ? "h-8 px-2 text-xs" : "";
  return (
    <div className={`flex flex-wrap items-center gap-2 ${compact ? "" : "rounded-lg border border-zinc-800 p-3"}`} data-testid={`initiative-share${idSuffix}`}>
      {!compact && <span className="text-xs font-semibold text-zinc-400 mr-1">Condividi con i clienti</span>}
      <a href={wa} target="_blank" rel="noreferrer" onClick={() => trackInitiative(d.slug, "share_wa", "admin")} className={`inline-flex items-center gap-1 rounded-md bg-emerald-600 hover:bg-emerald-500 text-white font-semibold ${compact ? "h-8 px-2 text-xs" : "h-9 px-3 text-sm"}`} data-testid={`initiative-share-wa${idSuffix}`}><MessageCircle className="h-4 w-4" /> WhatsApp</a>
      <Button type="button" variant="outline" size="sm" className={`border-zinc-700 ${cls}`} onClick={copy} data-testid={`initiative-share-copy${idSuffix}`}><Copy className="h-4 w-4 mr-1" /> Copia link</Button>
      <Button type="button" variant="outline" size="sm" className={`border-zinc-700 ${cls}`} onClick={() => { setQr(true); trackInitiative(d.slug, "share_qr", "admin"); }} data-testid={`initiative-share-qr${idSuffix}`}><QrCode className="h-4 w-4 mr-1" /> QR</Button>
      <Dialog open={qr} onOpenChange={setQr}>
        <DialogContent className="max-w-sm bg-zinc-900 border-zinc-800 text-zinc-100" data-testid={`initiative-qr-dialog${idSuffix}`}>
          <DialogHeader><DialogTitle>QR iniziativa · {d.headline}</DialogTitle></DialogHeader>
          <div className="flex flex-col items-center gap-3">
            <img src={qrSrc(260)} alt="QR" width={260} height={260} className="rounded-xl bg-white p-2" data-testid={`initiative-qr-img${idSuffix}`} />
            <div className="text-xs text-zinc-400 break-all text-center">{url}</div>
            <a href={qrSrc(900)} target="_blank" rel="noreferrer" download={`qr-${d.slug}.png`} className="inline-flex items-center gap-1 rounded-md border border-zinc-700 px-3 h-9 text-sm hover:bg-zinc-800" data-testid={`initiative-qr-download${idSuffix}`}><Download className="h-4 w-4" /> Scarica per la stampa</a>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
